<template lang="pug">
    .first-form.relative
        v-overlay(
            v-model="loading"
        )
            enl-loading
        v-container

            div(
                v-if="!formSent && !errorInfo"
            )
                .d-flex.justify-center
                    img(
                        :src="growattLogo"
                        height="80"
                    )
                v-form(ref="form")
                    v-row

                        //- DANE URZĄDZENIA
                        v-col(cols="12")
                            h1 Dane urządzenia

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Model urządzenia"
                                v-model="formData.deviceData.deviceName"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(
                            :cols="phablet?12:8"
                        ).py-0
                            v-text-field(
                                label="Numer seryjny (SN)"
                                v-model="formData.deviceData.serialNumber"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(
                            :cols="phablet?12:4"
                        ).py-0
                            enl-date-picker(
                                v-model="formData.deviceData.installationDate"
                                label="Data instalacji"
                                color="#339900"
                                filled
                                dense
                                :rules="textRules"
                            )

                        //- DANE INSTALATORA

                        v-col(cols="12")
                            h1 Dane instalatora

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Nazwa firmy"
                                v-model="formData.installatorData.companyName"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Osoba kontaktowa"
                                v-model="formData.installatorData.contactPerson"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Numer kontaktowy"
                                v-model="formData.installatorData.contactNumber"
                                :rules="phoneNumberRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Adres e-mail"
                                v-model="formData.installatorData.email"
                                :rules="emailRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(cols="12")
                            h3 Adres instalatora

                        v-col(
                            :cols="phablet?12:8"
                        ).py-0
                            v-text-field(
                                label="Ulica"
                                v-model="formData.installatorData.address.street"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(
                            :cols="phablet?6:4"
                        ).py-0
                            v-text-field(
                                label="Numer budynku"
                                v-model="formData.installatorData.address.buildingNumber"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(
                            :cols="phablet?6:4"
                        ).py-0
                            v-text-field(
                                label="Kod pocztowy"
                                v-model="formData.installatorData.address.zipCode"
                                :rules="zipCodeRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(
                            :cols="phablet?12:8"
                        ).py-0
                            v-text-field(
                                label="Miasto"
                                v-model="formData.installatorData.address.city"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="6").py-0
                            v-text-field(
                                label="Region"
                                v-model="formData.installatorData.address.region"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="6").py-0
                            v-select(
                                label="Państwo"
                                v-model="formData.installatorData.address.country"
                                :items="countries"
                                :item-text="item=>item.name_pl"
                                :item-value="item=>item.name_en"
                                :rules="textRules"
                                color="#339900"
                                required
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="12")
                            h3 Adres do zwrotu urządzenia

                        v-col(
                            :cols="phablet?12:8"
                        ).py-0
                            v-text-field(
                                label="Ulica"
                                v-model="formData.installatorData.returnAddress.street"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(
                            :cols="phablet?6:4"
                        ).py-0
                            v-text-field(
                                label="Numer budynku"
                                v-model="formData.installatorData.returnAddress.buildingNumber"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(
                            :cols="phablet?6:4"
                        ).py-0
                            v-text-field(
                                label="Kod pocztowy"
                                v-model="formData.installatorData.returnAddress.zipCode"
                                :rules="zipCodeRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(
                            :cols="phablet?12:8"
                        ).py-0
                            v-text-field(
                                label="Miasto"
                                v-model="formData.installatorData.returnAddress.city"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="6").py-0
                            v-text-field(
                                label="Region"
                                v-model="formData.installatorData.returnAddress.region"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="6").py-0
                            v-select(
                                label="Państwo"
                                v-model="formData.installatorData.returnAddress.country"
                                :items="countries"
                                :item-text="item=>item.name_pl"
                                :item-value="item=>item.name_en"
                                :rules="textRules"
                                color="#339900"
                                required
                                filled
                                dense
                                validate-on-blur
                            )


                        //- DANE UŻYTKOWNIKA

                        v-col(cols="12")
                            h1 Dane klienta końcowego

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Imię i nazwisko"
                                v-model="formData.customerData.customerName"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Numer kontaktowy"
                                v-model="formData.customerData.contactNumber"
                                :rules="phoneNumberRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Adres e-mail"
                                v-model="formData.customerData.email"
                                :rules="emailRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )


                        //- SPECYFIKACJA

                        v-col(cols="12")
                            h1 Specyfikacja aktualnych podłączeń

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Voc. (V):"
                                v-model="formData.specificationData.specification"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(cols="12").py-0
                            v-text-field(
                                label="Vmp. (V):"
                                v-model="formData.specificationData.vmp"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(cols="12").py-0
                            v-text-field(
                                label="Moc max. (W):"
                                v-model="formData.specificationData.power"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(cols="12").py-0
                            v-tooltip(
                                right
                            )
                                template(
                                    v-slot:activator="{ on, attrs }"
                                )
                                    v-text-field(
                                        label="Ilość obsługiwanych punktów MPPT (A/B)"
                                        v-model="formData.specificationData.pointsNumber"
                                        :rules="textRules"
                                        color="#339900"
                                        filled
                                        dense
                                        validate-on-blur
                                        v-bind="attrs"
                                        v-on="on"
                                    )
                                span W przypadku podłączenia jednego MPPT proszę wpisać <strong>1/0</strong>. <br> W przypadku podłączenia dwóch MPPT proszę wpisać <strong>1/1</strong>.
                        v-col(cols="12").py-0
                            v-tooltip(
                                right
                            )
                                template(
                                    v-slot:activator="{ on, attrs }"
                                )
                                    v-text-field(
                                        label="Ilość paneli podłączonych do punktu MPPT (A/B)"
                                        v-model="formData.specificationData.panelsNumber"
                                        :rules="textRules"
                                        color="#339900"
                                        filled
                                        dense
                                        validate-on-blur
                                        v-bind="attrs"
                                        v-on="on"
                                    )
                                span W przypadku podłączenia paneli pod 2 wejścia 1 MPPT<br>(19+18 paneli) oraz 0 wejść 2 MPPT proszę wpisać:<br><strong>19_18/0_0</strong>. W przypadku podłączenia paneli pod<br>2 wejścia 1 MPPT (19+18 paneli) oraz 3 wejścia 2 MPPT<br>(19+18+17) proszę wpisać <strong>19_18_0/19_18_17.</strong>
                        v-col(cols="12").py-0
                            v-text-field(
                                label="Aktualne napięcie w sieci AC (V) (L1/L2/L3)"
                                v-model="formData.specificationData.voltage"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        //- OPIS USZKODZENIA

                        v-col(cols="12")
                            h1 Opis uszkodzenia

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Informacja na wyświetlaczu"
                                v-model="formData.issueData.screen"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(cols="12").py-0
                            v-text-field(
                                label="Kolor diody LED"
                                v-model="formData.issueData.ledColor"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(cols="12").py-0
                            v-textarea(
                                label="Opis usterki"
                                v-model="formData.issueData.desc"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )
                        v-col(:cols="phone?12:12").py-0
                            v-text-field(
                                label="Osoba wypełniająca formularz (imię i nazwisko)"
                                v-model="formData.issueData.author"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        //- ZAŁĄCZNIKI

                        v-col(cols="12")
                            h1 Załączniki

                        v-col(cols="12")
                            files-panel(
                                v-model="formData.files.diagram"
                                label="Schemat instalacji"
                                ref="diagramFile"
                            )

                        //- Uwaga: 'Szkic instalacji' został zmieniony na 'Kartę katalogową paneli'
                        //- Zmienione tylko labele, nazwy obiektów po staremu dla zachowania kompatybilności z backendem.
                        //- ~PB

                        v-col(cols="12")
                            files-panel(
                                v-model="formData.files.sketch"
                                label="Karta katalogowa paneli"
                                ref="sketchFile"
                            )
                        v-col(cols="12")
                            files-panel(
                                v-model="formData.files.invoice"
                                label="Dowód zakupu"
                                ref="invoiceFile"
                            )

                        v-col(cols="12")
                            files-panel(
                                v-model="formData.files.electriciansLicence"
                                label="Uprawnienia elektryczne"
                                ref="electriciansLicenceFile"
                            )

                        //- BUTTONS

                        v-col(cols="12")
                            v-divider.mb-5
                            .d-flex.justify-space-between(
                                :class="phablet?'flex-column':''"
                            )
                                v-btn(
                                    color="success"
                                    depressed
                                    :width="phablet?'100%':350"
                                    @click="sendForm"
                                ).mr-3
                                    span.font-weight-bold Wyślij zgłoszenie
                                v-btn(
                                    text
                                    :width="phablet?'100%':250"
                                    @click="resetForm"
                                    :class="phablet?'mt-3': ''"
                                )
                                    v-icon(
                                        style="font-size: 20px"
                                    ).mr-1 cached
                                    span Wyczyść dane

            div(
                v-if="formSent && !errorInfo"
                style="height: calc(100vh - 24px)"
            ).d-flex.align-center.justify-center.flex-column
                img(
                    :src="growattLogo"
                    height="80"
                ).mb-4
                h3 Dziękujemy za zgłoszenie!

            div(
                v-if="errorInfo"
                style="height: calc(100vh - 24px)"
            ).d-flex.align-center.justify-center.flex-column
                img(
                    :src="growattLogo"
                    height="80"
                ).mb-4
                h3 Wystąpił błąd. Spróbuj ponownie.





</template>

<script>
import { mapActions, mapState } from "vuex";
import EnlDatePicker from "@/components/EnlDatePicker";
import FilesPanel from "@/components/filesUpload/FilesPanel";
import EnlLoading from "@/components/EnlLoading";

export default {
    name: "warranty-form",

    components: {
        EnlDatePicker,
        FilesPanel,
        EnlLoading
    },

    data: () => ({
        loading: false,
        formSent: false,
        formData: null,
        errorInfo: false,
        growattLogo: require("@/assets/logo.png"),
        emptyForm: {
            deviceData: {
                deviceName: null,
                serialNumber: null,
                installationDate: null
            },
            installatorData: {
                companyName: null,
                contactPerson: null,
                contactNumber: null,
                email: null,
                address: {
                    street: null,
                    buildingNumber: null,
                    city: null,
                    region: null,
                    zipCode: null,
                    country: null
                },
                returnAddress: {
                    street: null,
                    buildingNumber: null,
                    city: null,
                    region: null,
                    zipCode: null,
                    country: null
                }
            },
            customerData: {
                customerName: null,
                contactNumber: null,
                email: null
            },
            specificationData: {
                specification: null,
                vmp: null,
                power: null,
                pointsNumber: null,
                panelsNumber: null,
                voltage: null
            },

            issueData: {
                screen: null,
                ledColor: null,
                desc: null,
                author: null
            },

            files: {
                diagram: [],
                sketch: [],
                invoice: [],
                electriciansLicence: []
            },

            isSaved: false
        },

        // rules
        textRules: [
            val => {
                if (val) return true;
                else return "Pole jest wymagane";
                // return true;
            }
        ],
        emailRules: [
            val => {
                if (
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                        val
                    )
                ) {
                    return true;
                } else {
                    return "Podaj poprawny adres e-mail";
                }
                // return true;
            }
        ],
        phoneNumberRules: [
            val => {
                if (/^[\+\d]?(?:[\d-.\s()]*)$/.test(val)) {
                    return true;
                } else {
                    return "Podaj poprawny numer telefonu";
                }
                // return true;
            }
        ],
        zipCodeRules: [
            val => {
                if (/^[0-9]+(-[0-9]+)+$/.test(val)) {
                    return true;
                } else {
                    return "Podaj poprawny kod pocztowy";
                }
                // return true;
            }
        ]
    }),

    methods: {
        ...mapActions("firstForm", ["SEND_FORM"]),

        resetForm() {
            this.formData = JSON.parse(JSON.stringify(this.emptyForm));
        },

        validFiles() {
            let diagram = this.$refs.diagramFile.validate();
            let sketch = this.$refs.sketchFile.validate();
            let invoice = this.$refs.invoiceFile.validate();
            let electriciansLicence = this.$refs.electriciansLicenceFile.validate();
            if (diagram && sketch && invoice && electriciansLicence) {
                return true;
            } else {
                return false;
            }
        },

        async sendForm() {
            let validForm = await this.$refs.form.validate();
            let validFiles = await this.validFiles();
            const el = document.querySelector(".error--text:first-of-type");
            if (el) {
                this.$vuetify.goTo(el, { offset: 100 });
            }

            if (validForm && validFiles) {
                this.loading = true;
                let data = JSON.parse(JSON.stringify(this.formData));
                try {
                    let query = await this.SEND_FORM(this.formData);
                    this.loading = false;
                    this.formSent = true;
                } catch (error) {
                    this.loading = false;
                    this.errorInfo = true;
                    // console.log(error);
                }
            }
        }
    },

    computed: {
        ...mapState("countries", ["countries"])
    },

    created() {
        this.resetForm();
        document.title = "Formularz gwarancyjny Growatt";
    }
};
</script>

<style lang="sass" scoped>
@import "@/styles/global.sass"
</style>
